import React from 'react';
import {
  Alert,
  Box,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import { IPlanningReadiness } from './planningcontrol.models';

type Props = {
  readiness: IPlanningReadiness;
};

export default class ReadinessPanel extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { readiness } = this.props;
    const score = Math.max(0, Math.min(100, Number(readiness.score || 0)));

    return (
      <Stack spacing={2}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h6">Planning Readiness</Typography>
              <Typography variant="h5" fontWeight={800}>
                {score.toFixed(0)}%
              </Typography>
            </Stack>
            <LinearProgress
              variant="determinate"
              value={score}
              sx={{ height: 10, borderRadius: 5 }}
            />
          </Stack>
        </Paper>

        <Stack spacing={1}>
          {(readiness.components || []).map((component) => (
            <Paper key={component.code} variant="outlined" sx={{ p: 1.5 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  <Typography fontWeight={700}>{component.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    Weight {component.weight}%
                  </Typography>
                </Box>
                <Typography fontWeight={700}>
                  {Number(component.score || 0).toFixed(0)} / {component.weight}
                </Typography>
              </Stack>
            </Paper>
          ))}
        </Stack>

        {readiness.ready === 1 ? (
          <Alert severity="success">
            Planning Cycle is ready to open.
          </Alert>
        ) : (
          <Stack spacing={1}>
            {(readiness.blockers || []).map((blocker) => (
              <Alert key={blocker.code} severity="warning">
                {blocker.message}
              </Alert>
            ))}
          </Stack>
        )}
      </Stack>
    );
  }
}
